import OneHealth from "./screens/onehealth/OneHealth";
import EmbedFaceScan from "./screens/onehealth/EmbedFaceScan";
import EmbedPulmoScan from "./screens/onehealth/EmbedPulmoScan";
import SiteJourney from "./screens/onehealth/SiteJourney";
import { LangProvider, useLang } from "./screens/onehealth/OneHealthContext";
import { LTBrand, PoweredByCarePlix } from "./screens/onehealth/components";

/* CarePlix OneHealth — Fit-for-Work Readiness Screening (prototype).
   Single self-contained worker flow; state kept in memory.

   /embed/facescan  → standalone face-scan journey for host-app webviews
   /embed/pulmoscan → standalone lung-scan journey for host-app webviews
   Identity comes from URL params; the result is posted back to the host. */
const path = window.location.pathname.replace(/\/+$/, "");
const siteMatch = path.match(/^\/site\/([^/]+)$/);
let siteDeviceId = null;
if (siteMatch) {
  try {
    const decoded = decodeURIComponent(siteMatch[1]).trim();
    if (/^[A-Za-z0-9._~:@+-]{3,256}$/.test(decoded)) siteDeviceId = decoded;
  } catch (_) {}
}

function SiteRoute({ deviceId }) {
  const { dir } = useLang();
  return (
    <div className="oh-stage oh-site-route" dir={dir}>
      <div className="oh-device">
        <div className="oh-brandtop">
          <LTBrand />
          <div className="oh-brandtop-right"><PoweredByCarePlix /></div>
        </div>
        <div className="oh-screen"><SiteJourney deviceId={deviceId} /></div>
      </div>
    </div>
  );
}

function InvalidSiteRoute() {
  return (
    <LangProvider>
      <div className="oh-stage oh-site-route">
        <div className="oh-device">
          <div className="oh-screen">
            <div className="oh-view oh-preparing">
              <div className="oh-kicker">CarePlix OneHealth</div>
              <h1 className="oh-h1">Invalid device link</h1>
              <p className="oh-sub">Ask your site administrator for a valid device link.</p>
            </div>
          </div>
        </div>
      </div>
    </LangProvider>
  );
}

const App = () =>
  path === "/embed/facescan" ? <EmbedFaceScan />
  : path === "/embed/pulmoscan" ? <EmbedPulmoScan />
  : siteMatch && siteDeviceId ? <LangProvider><SiteRoute deviceId={siteDeviceId} /></LangProvider>
  : siteMatch ? <InvalidSiteRoute />
  : <OneHealth />;

export default App;
